"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REVENUE_MODEL_V6_SELECT_OPTIONS = exports.REVENUE_MODEL_V6 = exports.REVENUE_MODEL_SELECT_OPTIONS = exports.REVENUE_MODEL = exports.CompanyRevenueModelV6 = exports.CompanyRevenueModel = void 0;
const legacy_ui_1 = require("@hum/legacy-ui");
var CompanyRevenueModel;
(function (CompanyRevenueModel) {
    CompanyRevenueModel["Saas"] = "saas";
    CompanyRevenueModel["Transactional"] = "transactional";
    CompanyRevenueModel["Licensing"] = "licensing";
    CompanyRevenueModel["TakeRate"] = "take_rate";
})(CompanyRevenueModel = exports.CompanyRevenueModel || (exports.CompanyRevenueModel = {}));
var CompanyRevenueModelV6;
(function (CompanyRevenueModelV6) {
    CompanyRevenueModelV6["TransactionalConsumer"] = "transactional_consumer";
    CompanyRevenueModelV6["TransactionalEnterprise"] = "transactional_enterprise";
    CompanyRevenueModelV6["RecurringSaaS"] = "recurring_saas";
    CompanyRevenueModelV6["RecurringSubscription"] = "recurring_subscription";
    CompanyRevenueModelV6["RecurringLicensingRoyalties"] = "recurring_licensing_royalties";
    CompanyRevenueModelV6["TakeRate"] = "take_rate";
    CompanyRevenueModelV6["LendingFinance"] = "lending_finance";
    CompanyRevenueModelV6["ServiceProject"] = "service_project";
    CompanyRevenueModelV6["ServiceFee"] = "service_fee";
    CompanyRevenueModelV6["Other"] = "other";
})(CompanyRevenueModelV6 = exports.CompanyRevenueModelV6 || (exports.CompanyRevenueModelV6 = {}));
exports.REVENUE_MODEL = {
    [CompanyRevenueModel.Saas]: 'SaaS',
    [CompanyRevenueModel.Transactional]: 'Transactional (e.g. eCommerce)',
    [CompanyRevenueModel.Licensing]: 'Licensing',
    [CompanyRevenueModel.TakeRate]: 'Take rate (e.g. marketplace)',
};
exports.REVENUE_MODEL_SELECT_OPTIONS = (0, legacy_ui_1.selectOptionsFromMap)(exports.REVENUE_MODEL);
exports.REVENUE_MODEL_V6 = {
    [CompanyRevenueModelV6.TransactionalConsumer]: 'Transactional (Consumer)',
    [CompanyRevenueModelV6.TransactionalEnterprise]: 'Transactional (Enterprise)',
    [CompanyRevenueModelV6.RecurringSaaS]: 'SaaS (Recurring)',
    [CompanyRevenueModelV6.RecurringSubscription]: 'Subscription (Recurring)',
    [CompanyRevenueModelV6.RecurringLicensingRoyalties]: 'Licensing / Royalties (Recurring)',
    [CompanyRevenueModelV6.TakeRate]: 'Take Rate (eg. Marketplace)',
    [CompanyRevenueModelV6.LendingFinance]: 'Specialty Finance / Lending',
    [CompanyRevenueModelV6.ServiceProject]: 'Service (Project-based)',
    [CompanyRevenueModelV6.ServiceFee]: 'Service (Fee-for-service)',
    [CompanyRevenueModelV6.Other]: 'Other',
};
exports.REVENUE_MODEL_V6_SELECT_OPTIONS = (0, legacy_ui_1.selectOptionsFromMap)(exports.REVENUE_MODEL_V6);
//# sourceMappingURL=revenue.js.map